export default __webpack_public_path__ + "afb1562bfdfef6bb22fb2787626f6617.svg";